module.exports = __webpack_public_path__ + "static/_cbuLogo-0c7dbd133667a30e5c4702d997618e52.png";